import React from 'react';
import { useTranslation } from 'react-i18next';

import CommonButton, { BUTTON_STYLES } from '../../../../../components/common-button/CommonButton';
import CommonModal from '../../../../../components/common-modal/CommonModal';

import scss from './ResetSessionModal.module.scss';

function ResetSessionModal({ isOpen, onCancel, onChange, onChangeAndReset }) {
  const { t } = useTranslation('scout');

  return (
    <CommonModal isOpen={isOpen} onClose={onCancel} wrapperClassName={scss.wrapper}>
      <h3 className={scss.title}>{t('resetSession')}?</h3>

      <span className={scss.subTitle}>{t('assistantCouldLeadToErrors')}</span>

      <div className={scss.actions}>
        <CommonButton type='button' styleColor={BUTTON_STYLES.SECONDARY} maxWidth={90} onClick={onCancel}>
          {t('cancel')}
        </CommonButton>

        <div className={scss.actionsRight}>
          <CommonButton type='button' styleColor={BUTTON_STYLES.SECONDARY} maxWidth={160} onClick={onChange}>
            {t('submitWithoutReset')}
          </CommonButton>
          <CommonButton type='button' styleColor={BUTTON_STYLES.PRIMARY} maxWidth={160} onClick={onChangeAndReset}>
            {t('submitAndReset')}
          </CommonButton>
        </div>
      </div>
    </CommonModal>
  );
}

export default ResetSessionModal;
